/**
 * Device Presets for User Agent Configuration
 *
 * Defines device profiles with user agent strings, viewport dimensions,
 * and other browser emulation settings for cloud browser sessions.
 */

export const DEVICE_PRESETS = {
  current: {
    id: "current",
    label: "Your Browser",
    icon: "browser",
    userAgent: null, // uses detected browser UA
    viewport: null, // uses detected viewport
    isMobile: false,
  },
  "macbook-13": {
    id: "macbook-13",
    label: 'MacBook Air 13"',
    icon: "apple",
    userAgent:
      "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
    viewport: { width: 1366, height: 768 },
    isMobile: false,
    deviceScaleFactor: 2,
  },
  "macbook-15": {
    id: "macbook-15",
    label: 'MacBook Pro 15"',
    icon: "apple",
    userAgent:
      "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
    viewport: { width: 1440, height: 900 },
    isMobile: false,
    deviceScaleFactor: 2,
  },
  "windows-laptop": {
    id: "windows-laptop",
    label: 'Windows Laptop 15.6"',
    icon: "windows",
    userAgent:
      "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
    viewport: { width: 1920, height: 1080 },
    isMobile: false,
    deviceScaleFactor: 1,
  },
};

// Order for display in UI
export const DEVICE_PRESET_ORDER = ["current", "macbook-13", "macbook-15", "windows-laptop"];

/**
 * Format browser info for display
 * @param {{ name: string, os: string, viewport: { width: number, height: number } }} info
 * @returns {string}
 */
export const formatBrowserInfo = (info) => {
  if (!info) return "Your browser";
  return `Your ${info.name} on ${info.os} (${info.viewport.width}x${info.viewport.height})`;
};
